/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plantabplan2Inputs */

const en_plantabplan2 = /** @type {(inputs: Plantabplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const de_plantabplan2 = /** @type {(inputs: Plantabplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Plantabplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plantabplan2 = /** @type {((inputs?: Plantabplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plantabplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plantabplan2(inputs)
	return de_plantabplan2(inputs)
});
export { plantabplan2 as "planTabPlan" }